import { Environment } from 'models/environment';
import { createEmbedSessionImpression } from './create-embed-session-impression';

interface Params {
  stage: string;
  embedSessionId: string;
  loggedImpressions: string[];
  setLoggedImpressions: (v: string[]) => void;
  environment: Environment;
}

export const logEmbedSessionImpression = async (params: Params) => {
  const { stage, embedSessionId, loggedImpressions, setLoggedImpressions, environment } = params;

  // Do not log a new impression if the user has already completed the step
  if (loggedImpressions.includes(stage)) {
    return;
  }

  const embedSessionImpression = await createEmbedSessionImpression({
    embedSessionId,
    stage,
    environment,
  });

  setLoggedImpressions([...loggedImpressions, stage]);

  return embedSessionImpression;
};
